import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import DeviceRestriction from "./DeviceRestriction";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <DeviceRestriction>
    <App />
  </DeviceRestriction>
  // </React.StrictMode>
);